import React from 'react';
import { useParams } from 'react-router-dom';
import { KBHeader } from '../components/KBHeader';
import { ArticleView } from '../components/ArticleView';
import { articles } from '../data/articles';

export const ArticlePage: React.FC = () => {
  const { articleId } = useParams<{ articleId: string }>();
  const article = articles.find((a) => a.id === articleId);

  if (!article) {
    return (
      <div>
        <KBHeader onSearch={() => {}} />
        <div style={{ padding: '4rem', textAlign: 'center' }}>
          <h1>Article not found</h1>
        </div>
      </div>
    );
  }

  return (
    <>
      <KBHeader onSearch={() => {}} />
      <ArticleView article={article} />
    </>
  );
};








